module.exports = __webpack_public_path__ + "static/img/3_5.31d3a183.jpg";